import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { when as n } from '../../../../node_modules/lit-html/directives/when.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './mega-menu-panel.scss.js';
import '../../molecules/nav-item-group/index.js';
import '../nav-category/index.js';
import '../../atoms/featured-article/index.js';

class MegaMenuPanel extends s {
    constructor() {
        super(...arguments);
        this.label = '';
        this.open = false;
        this._onKeyDown = (e) => {
            if (e.key === 'Escape') {
                e.preventDefault();
                this.dispatchEvent(new CustomEvent('panel-close', {
                    bubbles: true,
                    composed: true,
                    detail: { moveFocusNext: false },
                }));
            }
        };
    }
    distributeNavGroups(groups) {
        const { withSubItems, titleOnly } = this.categorizeGroups(groups);
        if (withSubItems.length === 0 && titleOnly.length > 0) {
            return this.distributeTitleOnlyGroups(titleOnly);
        }
        return this.distributeMixedGroups(withSubItems, titleOnly);
    }
    categorizeGroups(groups) {
        const withSubItems = [];
        const titleOnly = [];
        for (const group of groups) {
            if (group.items && group.items.length > 0) {
                withSubItems.push(group);
            }
            else {
                titleOnly.push({
                    title: group.title,
                    target: group.target,
                    ariaLabel: group.ariaLabel,
                    isNoFollow: group.isNoFollow,
                    link: group.link || '#',
                    items: [],
                });
            }
        }
        return { withSubItems, titleOnly };
    }
    distributeTitleOnlyGroups(titleOnly) {
        const maxColumns = 3;
        const rows = [];
        let rowIndex = 0;
        for (const titleOnlyItem of titleOnly) {
            if (!rows[rowIndex]) {
                rows[rowIndex] = [];
            }
            rows[rowIndex].push({
                title: '',
                items: [Object.assign(Object.assign({}, titleOnlyItem), { isTitleOnly: true })],
                link: '',
                target: '',
                ariaLabel: '',
                isNoFollow: false,
            });
            if (rows[rowIndex].length === maxColumns) {
                rowIndex += 1;
            }
        }
        return rows;
    }
    distributeMixedGroups(withSubItems, titleOnly) {
        const maxColumns = titleOnly.length > 0 ? 2 : 3;
        const rows = [];
        let rowIndex = 0;
        for (const group of withSubItems) {
            if (!rows[rowIndex]) {
                rows[rowIndex] = [];
            }
            rows[rowIndex].push(group);
            if (rows[rowIndex].length === maxColumns) {
                rowIndex += 1;
            }
        }
        if (titleOnly.length > 0) {
            const titleOnlyGroup = {
                title: '',
                items: titleOnly.map(item => (Object.assign(Object.assign({}, item), { isTitleOnly: true }))),
                link: '',
                target: '',
                ariaLabel: '',
                isNoFollow: false,
            };
            if (!rows[0]) {
                rows[0] = [];
            }
            rows[0].push(titleOnlyGroup);
        }
        return rows;
    }
    connectedCallback() {
        super.connectedCallback();
        this.addEventListener('keydown', this._onKeyDown);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener('keydown', this._onKeyDown);
    }
    renderNavCategory() {
        var _a;
        return n((_a = this.data) === null || _a === void 0 ? void 0 : _a.menuNavCategory, () => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8;
            return $ `<nav-category .heading="${(_c = (_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.menuNavCategory) === null || _b === void 0 ? void 0 : _b.title) !== null && _c !== void 0 ? _c : ''}" .description="${(_f = (_e = (_d = this.data) === null || _d === void 0 ? void 0 : _d.menuNavCategory) === null || _e === void 0 ? void 0 : _e.description) !== null && _f !== void 0 ? _f : ''}" .icon="${(_j = (_h = (_g = this.data) === null || _g === void 0 ? void 0 : _g.menuNavCategory) === null || _h === void 0 ? void 0 : _h.categoryIcon) !== null && _j !== void 0 ? _j : ''}" .buttonText="${(_o = (_m = (_l = (_k = this.data) === null || _k === void 0 ? void 0 : _k.menuNavCategory) === null || _l === void 0 ? void 0 : _l.cta) === null || _m === void 0 ? void 0 : _m.text) !== null && _o !== void 0 ? _o : ''}" .buttonHref="${(_s = (_r = (_q = (_p = this.data) === null || _p === void 0 ? void 0 : _p.menuNavCategory) === null || _q === void 0 ? void 0 : _q.cta) === null || _r === void 0 ? void 0 : _r.link) !== null && _s !== void 0 ? _s : ''}" .ariaLabel="${(_w = (_v = (_u = (_t = this.data) === null || _t === void 0 ? void 0 : _t.menuNavCategory) === null || _u === void 0 ? void 0 : _u.cta) === null || _v === void 0 ? void 0 : _v.ariaLabel) !== null && _w !== void 0 ? _w : ''}" .target="${(_z = (_y = (_x = this.data) === null || _x === void 0 ? void 0 : _x.menuNavCategory) === null || _y === void 0 ? void 0 : _y.cta) === null || _z === void 0 ? void 0 : _z.target}" .isNoFollow="${(_2 = (_1 = (_0 = this.data) === null || _0 === void 0 ? void 0 : _0.menuNavCategory) === null || _1 === void 0 ? void 0 : _1.cta) === null || _2 === void 0 ? void 0 : _2.isNoFollow}" .links="${(_5 = (_4 = (_3 = this.data) === null || _3 === void 0 ? void 0 : _3.menuNavCategory) === null || _4 === void 0 ? void 0 : _4.navLinks) !== null && _5 !== void 0 ? _5 : []}" .buttonId="${(_6 = this.data) === null || _6 === void 0 ? void 0 : _6.title}" .isCMSIcon="${((_8 = (_7 = this.data) === null || _7 === void 0 ? void 0 : _7.menuNavCategory) === null || _8 === void 0 ? void 0 : _8.isCMSIcon) || false}"></nav-category>`;
        });
    }
    renderNavItemGroups(groups) {
        return groups.map(group => $ `<nav-item-group title="${group.title || ''}" .subItems="${group.items}" .linkHref="${group.link || '#'}" .target="${group.target || '_self'}" .ariaLabel="${group.ariaLabel || ''}" .isNoFollow="${group.isNoFollow || false}"></nav-item-group>`);
    }
    renderFeaturedArticle(rows) {
        var _a, _b, _c, _d, _e;
        return n(((_c = (_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.featuredArticle) === null || _b === void 0 ? void 0 : _b.navLink) === null || _c === void 0 ? void 0 : _c.text) &&
            ((_e = (_d = this.data) === null || _d === void 0 ? void 0 : _d.featuredArticle) === null || _e === void 0 ? void 0 : _e.text), () => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
            return $ `<div class="bottom-container" style="grid-row:${rows.length + 1};grid-column:2/5"><featured-article .text="${(_c = (_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.featuredArticle) === null || _b === void 0 ? void 0 : _b.text) !== null && _c !== void 0 ? _c : ''}" .linkText="${(_g = (_f = (_e = (_d = this.data) === null || _d === void 0 ? void 0 : _d.featuredArticle) === null || _e === void 0 ? void 0 : _e.navLink) === null || _f === void 0 ? void 0 : _f.text) !== null && _g !== void 0 ? _g : ''}" .linkHref="${(_l = (_k = (_j = (_h = this.data) === null || _h === void 0 ? void 0 : _h.featuredArticle) === null || _j === void 0 ? void 0 : _j.navLink) === null || _k === void 0 ? void 0 : _k.link) !== null && _l !== void 0 ? _l : ''}" .ariaLabel="${(_q = (_p = (_o = (_m = this.data) === null || _m === void 0 ? void 0 : _m.featuredArticle) === null || _o === void 0 ? void 0 : _o.navLink) === null || _p === void 0 ? void 0 : _p.ariaLabel) !== null && _q !== void 0 ? _q : ''}" .isNoFollow="${(_u = (_t = (_s = (_r = this.data) === null || _r === void 0 ? void 0 : _r.featuredArticle) === null || _s === void 0 ? void 0 : _s.navLink) === null || _t === void 0 ? void 0 : _t.isNoFollow) !== null && _u !== void 0 ? _u : false}" .target="${(_x = (_w = (_v = this.data) === null || _v === void 0 ? void 0 : _v.featuredArticle) === null || _w === void 0 ? void 0 : _w.navLink) === null || _x === void 0 ? void 0 : _x.target}"></featured-article></div>`;
        });
    }
    renderColumns(columns) {
        return columns.map(({ group, rowIndex, colIndex }) => {
            const gridRow = rowIndex + 1;
            const gridColumn = colIndex + 2;
            return $ `<div class="column" style="grid-row:${gridRow};grid-column:${gridColumn}">${this.renderNavItemGroups([group])}</div>`;
        });
    }
    render() {
        var _a, _b, _c, _d;
        const navGroups = ((_a = this.data) === null || _a === void 0 ? void 0 : _a.items) || [];
        const rows = this.distributeNavGroups(navGroups);
        const columns = rows.flatMap((row, rowIndex) => row.map((group, colIndex) => ({ group, rowIndex, colIndex })));
        const totalRows = rows.length + 1;
        const gridTemplateRows = `grid-template-rows: repeat(${totalRows}, auto);`;
        const ariaLabelValue = ((_b = this.data) === null || _b === void 0 ? void 0 : _b.title)
            ? `${this.data.title} submenu`
            : 'submenu';
        const panelId = ((_d = (_c = this.data) === null || _c === void 0 ? void 0 : _c.title) === null || _d === void 0 ? void 0 : _d.toLowerCase().replace(/\s+/g, '-')) || '';
        return $ `<div class="panel-content" id="panel-${panelId}" style="${gridTemplateRows}" aria-label="${ariaLabelValue}" aria-hidden="${!this.open}"><div class="first-column">${this.renderNavCategory()}</div>${this.renderColumns(columns)} ${this.renderFeaturedArticle(rows)}</div>`;
    }
}
MegaMenuPanel.styles = css_248z;
__decorate([
    e({ type: String })
], MegaMenuPanel.prototype, "label", void 0);
__decorate([
    e({ type: Object })
], MegaMenuPanel.prototype, "data", void 0);
__decorate([
    e({ type: Boolean })
], MegaMenuPanel.prototype, "open", void 0);
customElements.define('mega-menu-panel', MegaMenuPanel);

export { MegaMenuPanel };
